import React from "react";
import { AI_GRADIENT } from "@glossy/mixins";

export default () => (
  <svg width="100%" height="100%" viewBox="0 0 73.59 64.23">
    <defs>
      <linearGradient
        id="a"
        x1="0"
        x2="73.59"
        y1="32.08"
        y2="32.08"
        gradientTransform="matrix(1 0 0 -1 0 64.12)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color={AI_GRADIENT.start} />
        <stop offset="1" stop-color={AI_GRADIENT.end} />
      </linearGradient>
    </defs>
    <path
      fill="url(#a)"
      d="m27.44 41.96 4.52-9.9 9.9-4.62-9.9-4.52-4.52-9.9-4.62 9.9-9.9 4.52 9.9 4.62 4.62 9.9Zm0 12.91-8.68-18.76L0 27.44l18.76-8.57L27.44 0l8.57 18.86 18.86 8.57-18.86 8.68-8.57 18.76Zm32.43 9.36-4.39-9.33-9.33-4.39 9.33-4.29 4.39-9.43 4.29 9.43 9.43 4.29-9.43 4.39-4.29 9.33Z"
    />
  </svg>
);
